import { TestMessageParams } from "yup";

export const yupRequiredField = (params: Partial<TestMessageParams>) => {
    return `Campo obrigatório!`;
};

export const yupInvalidEmail = (params: Partial<TestMessageParams>) => {
    return `Email inválido!`;
};

export const yupMaxLengthField = (params: Partial<TestMessageParams>) => {
    return `Max.: ${params.value.length} / ${params["max"]}. Limite de caracteres excedido!`;
};

export const yupMinLengthField = (params: Partial<TestMessageParams>) => {
    return `Informe pelo menos ${params["min"]} caracteres. ${params.value.length} / ${params["min"]}`;
};

export const yupMinValueField = (params: Partial<TestMessageParams>) => {
    return `O valor mínimo é ${params["min"]}`;
};
